import React, { Component } from "react";
import { ROOT } from "../../constants";
import getCookie from "../../function/getCookie";
import isUrlEn from "../../function/isUrlEn";
import i18n from "i18next";
import { Translation } from "react-i18next";
import { Helmet } from "react-helmet";

export class VerificationEmail extends Component {
  state = {
    lang: "zhTW"
  };
  componentDidMount() {
    /*先抓URL判斷語系*/
    const url = window.location.pathname;
    isUrlEn(url);
    // 重整頁面先到cookie拿語系
    const lang =
      this.props.match.params.lang || getCookie("hk-emphasis-language");
    console.log(this.props);
    if (lang === "en") {
      i18n.changeLanguage("en");
      this.setState({
        lang: "en"
      });
    } else {
      i18n.changeLanguage("zhTW");
      this.setState({
        lang: "zhTW"
      });
    }
  }
  render() {
    const pathLang = getCookie("hk-emphasis-language") === "en" ? "en" : "tc";
    const description =
      pathLang === "en"
        ? "At EMPHASIS, we embrace different styles and looks, resonating with the tastes of women from all walks of life. Our original designs are more than pretty accessories. They are designed to complete your look and express your individuality. We live in a world that imposes expectations on beauty. Our logo, featuring the stylised outline of an unconventional crown, is a proud symbol of our mission to challenge these expectations and let your inner strength shine through. Crown the Beautiful You."
        : "EMPHASIS 的原創珠寶不僅精緻瑰麗，我們獨特多變的設計更能圓滿妳的妝容服飾，展露自我風格。妳我縱使身處受標準審美限制的大時代，但我們品牌標誌上象徵富棱角的后冠能賦予妳勇於衝破枷鎖的力量，讓妳盡情綻放自己的獨特個性，閃爍耀眼。冠冕女性之美。";

    return (
      <>
        <Helmet>
          <title>EMPHASIS</title>
          <meta name="description" content={description} />
        </Helmet>
        <div style={{ width: "100%", marginTop: "20%" }}>
          <div style={{ width: "50%", margin: "0 auto", textAlign: "center" }}>
            <p style={{ textAlign: "center" }}>
              <Translation>{t => t("checkout.verificationEmail")}</Translation>
            </p>
            <button
              style={{
                width: "50%",
                margin: "0 auto",
                backgroundColor: "#000",
                color: "#fff",
                padding: "16px"
              }}
              onClick={() => {
                window.location.href = `${ROOT}/${pathLang}/checkout`;
              }}
            >
              <Translation>{t => t("checkout.back")}</Translation>
            </button>
          </div>
        </div>
      </>
    );
  }
}

export default VerificationEmail;
